class @App.Clubs.ClubsResourcesView
  constructor: ->
    @bindElements()

  bindElements: =>
    $(document).on 'change', '[data-action="updateResourcesApplication"]', (e) ->
      input = $(this)
      window.location.href = '/student_talks/resources/?application_id='+ input.val()
    scrollToPromo()

  scrollToPromo = ->
    return if window.location.hash != 'share-clubs'
    document.getElementById('share-clubs').scrollIntoView();

    return

$ ->
  new App.Clubs.ClubsResourcesView() if $('.clubsResourcesView').length
